import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import DriverView from "@/pages/DriverView";
import DaySheet from "@/pages/DaySheet";
import Beiladungen from "@/pages/Beiladungen";
import Volumenrechner from "@/pages/Volumenrechner";
import RequestWizard from "@/pages/RequestWizard";
import Angebote from "@/pages/Angebote";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import CustomerDashboard from "@/pages/CustomerDashboard";
import PartnerPortal from "@/pages/PartnerPortal";
import Admin from "@/pages/Admin";
import SeoRoute from "@/pages/SeoRoute";
import Legal from "@/pages/Legal";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Lädt…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/aktuelle-beiladungen" element={<Beiladungen />} />
        <Route path="/volumenrechner" element={<Volumenrechner />} />
        <Route path="/anfrage" element={<RequestWizard />} />
        <Route path="/angebote/:requestId" element={<Angebote />} />
        <Route path="/checkout/:bookingId" element={<Protected><Checkout /></Protected>} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registrieren" element={<Register />} />
        <Route path="/dashboard" element={<Protected><CustomerDashboard /></Protected>} />
        <Route path="/partner" element={<PartnerPortal />} />
        <Route path="/partner/fahrer" element={<DriverView />} />
        <Route path="/partner/tagesplan" element={<DaySheet />} />
        <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
        <Route path="/:seoSlug" element={<SeoRoute />} />
        <Route path="/rechtliches/:page" element={<Legal />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App eb-grain">
      <AuthProvider>
        <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}
